import { LayoutGroup } from "framer-motion";
import { Outlet } from "react-router-dom";
import { SidebarPortal } from "@/features/Navigation/components/SidebarPortal";
import { atom } from "jotai";

export const showDealListAtom = atom(true);

export function DealsLayout() {
    return (
        <LayoutGroup>
            <SidebarPortal>
                <div>
                    <p>deal list here</p>
                </div>
            </SidebarPortal>
            <Outlet />
        </LayoutGroup>
    );
}
